<template>
	<section>
		<!--Toolbar -->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">        
        <el-form-item>Site:</el-form-item>
				
        <el-form-item>
				  <el-select size='small' style='width:200px' v-model="sitecode" Placeholder='Select Site' @change='startSearch'>
          <el-option v-for="item in codes.sites" 
      		           :key='item.code' 
			 	             :label="item.code + ' - ' + item.name" 
			  	  				 :value='item.code'></el-option>
  		    </el-select>
				</el-form-item>
        
        <el-form-item v-if="this.searchField != 'Dossier' || this.searchFilter == ''" >
				  <el-select size='small' style='width:160px' v-model="periode" Placeholder='Vanaf periode' @change='startSearch'>
          <el-option v-for="item in codes.periods" 
      		           :key='item.code' 
			 	             :label="item.value" 
			  	  				 :value='item.code'></el-option>
  		    </el-select>
				</el-form-item>
        <el-form-item>
          Filter:&nbsp;
				  <el-select size='small' style='width:150px' v-model="searchField" Placeholder='Select field'>
          <el-option v-for="item in searchFields" 
      		           :key='item' 
			 	             :label="item" 
			  	  				 :value='item'></el-option>
  		    </el-select>
				</el-form-item>
				
        <el-form-item>
					<el-input size='small' v-model="searchFilter" placeholder="Search For"></el-input>
				</el-form-item>
				
        <el-form-item>
					<el-button type="primary" icon='el-icon-search' size='small' v-on:click="startSearch">Filter</el-button>
				</el-form-item>
        
        <span style='float:right'>
  				<el-form-item>
	  				<el-button type="primary" size="small" icon="el-icon-plus" @click="handleImport">Import</el-button>
		  		</el-form-item>
				</span>
			</el-form>
		</el-col>

		<!--Lijst-->
		<el-table :data="content" stripe highlight-current-row v-loading="listLoading" style="width: 100%;">
      <el-table-column prop="D" label="Dossier" width="120" sortable></el-table-column>
      <el-table-column prop="P" label="Period" width="100" sortable></el-table-column>
      <el-table-column prop="B" label="Booker" min-width="120" sortable></el-table-column>
      <el-table-column prop="X" label="Destination" min-width="120" sortable></el-table-column>
      <el-table-column prop="S" label="Departure" width="110" sortable></el-table-column>
      <el-table-column align='right' prop="A" label="Amount" width="100">
				<template slot-scope="scope"> {{util.formatMoney(scope.row.A)}} </template>
      </el-table-column>
      <el-table-column prop="b" label="BS" width="50"></el-table-column>
      <el-table-column prop="l" label="LS" width="50"></el-table-column>

      <el-table-column label="" width="140" fixed='right'>

				<template slot-scope="scope">
					<el-button type='success' size="small" icon="el-icon-view"  @click="handleEdit(scope.row)"></el-button>
					<el-button type='primary' size="small" icon="el-icon-chat-line-square"  @click="handleView(scope.row)"></el-button>
					<el-button type='warning' size="small" icon="el-icon-aim"  @click="handleXml(scope.row,0)"></el-button>
          <!--<el-button type="warning" size="small" xicon="el-icon-delete"  @click="handleXml(scope.row,1)">Z</el-button>-->
				</template>
			</el-table-column>
		</el-table>

		<!-- Toolbar -->
		
		<el-col :span="24" class="toolbar">
			<el-pagination layout="prev,pager,next,jumper,sizes" @current-change="selectPage" :total="mainTotal" style="float:right;"
                     :page-sizes="[10, 15, 25, 50, 100]"  :current-page='currentPage' @size-change="selectPagesize" :page-size="pageSize"></el-pagination>
      <span style='font-size:80%;margin:9px;float:right'>{{mainTotal}} records found</span>
      </el-col>
    
		<!--Wijzig record -->
		<el-dialog :title="editTitle" :visible.sync="editFormVisible" 
                   :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="editForm" label-width="140px" :rules="editFormRules" ref="editForm">
        <el-tabs type="card" style='height:440px' @tab-click="clickTab" v-model='currentTab'>
          <!-- -------------------------------------------------------------------------------------- -->
				  <el-tab-pane name='T1'> 
            <span slot='label'><i class='el-icon-date'></i> Dossier</span>

            <el-form-item label="Dossier/Status : ">
              <el-input style='width:420px' :disabled="this.editMode=='save'" v-model="editForm['D']" auto-complete="off"></el-input>
              <el-input style='width:100px;float:right' disabled v-model="editForm['l']" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="Booker : ">
              <el-input disabled v-model="editForm['B']" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="Main Dest : ">
              <el-input disabled v-model="editForm['D']" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="Bookdate : ">
             <el-date-picker disabled style='width:250px;'
                  v-model="editForm['a']" type="datetime" :clearable="true"
                  placeholder="Select Date and Time"
                  format="yyyy-MM-dd"
                  class="startTimeBox">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="Departuredate : ">
              <el-date-picker disabled style='width:250px;'
                  v-model="editForm['S']" type="datetime" :clearable="true"
                  placeholder="Select Date and Time"
                  format="yyyy-MM-dd"
                  class="startTimeBox">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="Returndate : ">
              <el-date-picker disabled style='width:250px;'
                  v-model="editForm['e']" type="datetime" :clearable="true"
                  placeholder="Select Date and Time"
                  format="yyyy-MM-dd"
                  class="startTimeBox">
              </el-date-picker>
            </el-form-item>
            <!--
            <el-form-item>
            <hr color='#eee'>
            </el-form-item>
             -->
            <el-form-item label="Dossier Geladen : ">
              <el-date-picker disabled style='width:250px;'
                  v-model="editForm['c']" type="datetime" :clearable="true"
                  placeholder="Select Date and Time"
                  format="yyyy-MM-dd HH:mm:ss"
                  class="startTimeBox">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="Booked By : ">
              <el-input style='width:250px' disabled v-model="editForm['m']" auto-complete="off"></el-input>
            </el-form-item>

            
          </el-tab-pane>
          <!-- -------------------------------------------------------------------------------------- -->
			    <el-tab-pane  name='LOCATE'> <span slot='label'><i class='el-icon-date'></i> Segments</span>
            <el-form-item label="Accommodation : ">
              <el-input rows=8 readonly='readonly' type='textarea' v-model="detailLocate"></el-input>
            </el-form-item>
            <el-form-item label="Transport : ">
              <el-input rows=9 readonly='readonly' type='textarea' v-model="detailTransport"></el-input>
            </el-form-item>
          </el-tab-pane>

          <!-- -------------------------------------------------------------------------------------- -->
			    <el-tab-pane  name='FIN'> <span slot='label'><i class='el-icon-date'></i> Finance</span>
            <el-form-item label="Details : ">
                <el-input rows=18 readonly='readonly' type='textarea' v-model="detailFin"></el-input>

            </el-form-item>
    
          <!-- -------------------------------------------------------------------------------------- -->
          </el-tab-pane>
          <!-- -------------------------------------------------------------------------------------- -->

      	</el-tabs>
      

      </el-form>
			<div slot='footer' style='height:40px'>					
        <el-button size='small' style='float:right;' type="primary" @click.native="editFormVisible=false" icon="el-icon-close" :loading="editLoading">Close</el-button>
      </div>
			
      <!--
      <div slot="footer" class="dialog-footer">		  
				<el-button size='small' icon="el-icon-upload2"  @click.native="editFormVisible = false">{{lang.butCancel}}</el-button>
				<el-button size='small' type="primary" icon="el-icon-edit"  @click.native="editFormVisible = false" :loading="editLoading">Close</el-button>
			</div>
      -->
		</el-dialog>

    <!-- -------------------------------------------------------------------------------------- -->
    <!-- DIALOG VIEW XML                                                                        -->
    <!-- -------------------------------------------------------------------------------------- -->
      
    <el-dialog width='90%' title="View Original XML" :visible.sync="viewXmlVisible" 
                   :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="editForm" label-width="120px">
				<!-- ----------------------------------------------------------------- -->
		    <el-form-item label="Dossier:" prop="dossier">
					<el-input disabled v-model="dossier" auto-complete="off"></el-input>
			  </el-form-item>
        
        <el-form-item label="Location:" prop="id">
					<el-input disabled v-model="xmlfile" auto-complete="off"></el-input>
			  </el-form-item>
        
        <el-form-item label="XML : "   v-loading="listLoading" >
          <el-input readonly type='textarea' rows='25' style='font-family:system;font-size:12px' v-model="xmldata"></el-input>
        </el-form-item>
		  	<!-- ----------------------------------------------------------------- -->      
				<div style='height:40px'>					
          <el-button style='float:right;' type="primary" @click.native="viewXmlVisible=false" icon="edit" :loading="editLoading">Close</el-button>
        </div>
      </el-form>
		</el-dialog>
    

    <!-- -------------------------------------------------------------------------------------- -->
    <!-- DIALOG VIEW DETAILS                                                                    -->
    <!-- -------------------------------------------------------------------------------------- -->
      
    <el-dialog width='90%' title="View Base Dossier Details" :visible.sync="viewDetailsVisible" 
                   :close-on-click-modal="false" :close-on-press-escape="false">

		  <el-form style='min-height:450px;' :model="editForm" label-width="120px">
	      <el-form-item label="Dossier :" prop="dossier">
					<el-input disabled v-model="dossier" auto-complete="off" style='width:300px'></el-input>
 				  <el-select size='small' style='width:100px;float:Right' v-model="outtype" Placeholder='Select Type' @change='reloadData'>
          <el-option v-for="item in outtypes" 
      		           :key='item' 
			 	             :label="item" 
			  	  				 :value='item'></el-option>
  		    </el-select>
			  </el-form-item>
         <el-form-item label="JSON : "   v-loading="listLoading" >
          <el-input readonly type='textarea' rows='28' style='font-family:system;font-size:12px' v-model="outdata"></el-input>
        </el-form-item>
        <!-- ----------------------------------------------------------------- -->        
				<div style='height:40px'>					
          <el-button style='float:right;' type="primary" @click.native="viewDetailsVisible=false" icon="edit" :loading="editLoading">Close</el-button>
        </div>
			</el-form>
    </el-dialog>			

    <!-- -------------------------------------------------------------------------------------- -->

	</section>
</template>

<script>
  import settings from '../../common/AppSettings';
 	import util     from '../../common/AppUtil';
  import text     from '../../common/AppText';
  import api      from '../../api/bas/dossier';

	export default {
		data() {
			return {
        searchFields: ["Dossier","Booker","Destination","Segment"],
        statusList  : [{cd:0,va:"Open"},{cd:1,va:"Processing"},{cd:2,va:"Loaded"},{cd:3,va:"Pushed to Racs"},{cd:5,va:"Load Error"},{cd:6,va:"Push Error"},{cd:9,va:"SKIP this Dossier"}],
        QID         : util.Initialize(this.$router,"Dossier"),
        util        : util,
        stack       : {},
			  lang        : text.data,
        codes       : util.codes,
				pageSize    : settings.pageSize,
 		  	serverPaging: false,
        periode     : "1",
        periodeLast : "1",
        sitecode    : "BC",
        stage       : window.stage,

        currentTab  : "T1",
        
        anonymize   : true,
        numRecs     : 250,
        sitecode    : "",

        viewXmlVisible: false,
        viewDetailsVisible:false,
 				outtypes    : ["JSON","XML"],
        outtype     : "JSON",
        currentTab  : "T1",
        outdata     : "",
        dossier     : "",
        xmldata     : "",
        xmlfile     : "",




				editTitle   : "",
				editMode    : "",
        userDepts   : "",
        userRoles   : "",
				APICode     : "BasDossier",
				mainFunc    : "Dossier",
				mainSubject : "Dossier",
        mainKey     : "D",
				mainKeyDesc : "D",
        searchFilter: '',				
        content: [],
				counter: {},
				related: [],
				currentPage: 1,
				mainTotal: 0,
        searchField: "Booker",
        detailFin: "",
        detailHist: "",
        detailLocate: "",
        detailFinLoaded: false,
        detailHistLoaded: false,
        detailLocateLoaded: false,
        detailTransport: "",
		
				listLoading: false,
				editFormVisible: false,// Of de bewerkingsinterface wordt weergegeven
				editLoading: false,
				editForm: {},			
				editFormRules: {
					siteid: [
						{ required: true, message: text.data.mandatory, trigger: 'blur' }
					]
				},

			}
		},
		
		methods: {

      closeForm: function () {
         this.selectorVisible = false;
	  		this.$router.push({name: 'Employees',params: this.stack});
    	},


		  startSearch: function() {
       if (this.periode.startsWith("."))
        {
          this.periode = this.periodeLast;
        }
        else {
          this.periodeLast = this.periode;
          this.currentPage = 1;
          this.content = [];        
          this.getRecords();
        }
      },
    // paginering wissel, reload page			
		  selectPagesize: function(size) {
				settings.pageSize = size;
				this.showPagedData();
			},
			selectPage: function(page) {
				this.currentPage = page;								
				this.showPagedData();
			},
			showPagedData: function() {
				if (this.serverPaging) this.getRecords();
				else this.content = this.contentSaved.slice((this.currentPage - 1) * 
				                    settings.pageSize,this.currentPage * settings.pageSize);
      },

			// Ophalen record(s) via API
			getRecords() {
				let parg = {};
        parg.Params = {};
        parg.Params.site = this.sitecode;
        parg.Params.period = this.periode;
        parg.Params.search = this.searchFilter;
        parg.Params.field = this.searchField;
        parg.Params.currentPage = this.currentPage;

        parg.Params.pageNum  = this.currentPage;

        util.setSessionValue("site",this.sitecode);
        util.setSessionValue("period",this.periode);

				this.listLoading = true;
				
				api.getListPage(parg).then((res) => {						
          util.processMainResults(res);
          this.codes = util.codes;          
          this.mainTotal = util.header["totalRecs"]; 
         

          if (this.sitecode == "" && this.codes.sites[0]) this.sitecode = this.codes.sites[0].code;

          if (this.mainTotal > 0)
          {
            if (this.serverPaging)
           	  this.content = util.getMainPayload(this.APICode);
			  		else {
 				  		this.contentSaved = util.getMainPayload(this.APICode);
  				    if (this.contentSaved.length > 0)
    				    this.selectPage(1);
  					}
          }
					else {
            this.content = [];
            this.contentSaved = [];
          }
          this.listLoading = false;
				})
        .catch((error) => {
          util.serverError(this);
        });

			},

      clickTab: function(tab,event) {
        if (this.currentTab == "FIN" && this.detailFinLoaded  == false) this.openTabDetails("fin");
        else if (this.currentTab == "HIST" && this.detailHistLoaded == false) this.openTabDetails("hist");
        else if (this.currentTab == "LOCATE" && this.detailLocateLoaded == false) this.openTabDetails("locate");
      },

      openTabDetails(loadSet) {
        if (loadSet != "") {
          let parg = {};
          parg.Params = {};
          parg.Params.site    = this.sitecode;
          parg.Params.period  = this.periode;
          parg.Params.search  = this.searchFilter;
          parg.Params.field   = this.searchField;
          parg.Params.dosid   = this.editForm['D'];
          parg.Params.currentPage = this.currentPage;
          parg.Params.loadset = loadSet;

          api.execute('findet',parg).then((res) => {		
            var d = res.data;
            if (typeof(d) === "string") d = JSON.parse(res.data);   // convert non-aws string to 
            
            if (loadSet == 'fin') {
              this.detailFin        = d.payload.findet;
              if (this.detailFin == "") this.detailFin = "- No details -";
              this.detailFinLoaded  = true;
            }
            else if (loadSet == 'hist') {
              this.detailHist       = d.payload.findet;
              this.detailHistLoaded = true;
            }
            else if (loadSet == 'locate') {
              this.detailLocate       = d.payload.verblijf;
              this.detailTransport    = d.payload.transport;
              if (this.detailLocate == "") this.detailLocate = "- No details -";
              if (this.detailTransport == "") this.detailTransport = "- No details -";
              this.detailLocateLoaded = true;
            }
          })
          .catch((error) => {
            util.serverError(this);
          });
        
        }
      },

			openRelated: function(row) {       
			},

			// Verwijder
			handleDel: function (row) {
				this.$confirm(text.getText("sdelM",this.mainSubject,row[this.mainKeyDesc]), 'Confirm', {
					type: 'warning',title: text.getText("sdelT",this.mainSubject)
				}).then(() => {
					this.listLoading = true;
				  let parg = {};
          parg.Params = {};
          //parg.Params['site'] = row.site;
          parg.Params['dosid'] = row.D;

				  api.removeRecord(parg).then((res) => {
						this.listLoading = false;
  					this.$notify({
	  				  title: text.data.conf,type: 'success',
		  				message: text.getText("delOK",this.mainSubject,row[this.mainKey])			  			              
				  	});
						this.getRecords();
					});

				}).catch(() => {

				});
			},
			
			// Display bewerkingsinterface
			handleEdit: function (row) {
        this.editMode = "save";
				this.editTitle = "View BAS Dossier " + row[this.mainKey];//text.getText("modM",this.mainSubject,row[this.mainKey]);
				this.editFormVisible = true;
				this.editForm = Object.assign({}, row);
        this.detailFin = "";
        this.detailHist = "";
        this.detailLocate = "";       
        this.detailFinLoaded = false;
        this.detailHistLoaded = false;
        this.detailLocateLoaded = false;
        this.currentTab = "T1";
     
        //this.$nextTick(() => this.$refs.firstEdit.focus());
			},
		  
      handleView: function (row) {
        this.getDetailData(row.D);        
			},

      reloadData: function() {
        this.getDetailData(this.dossier);
      },

      getDetailData: function(dosid) {
        let parg = {};
        parg.Params = {};
        parg.Params.site = this.sitecode;
        parg.Params.dosid = dosid;
        this.dossier = dosid;
        parg.Params.period = this.periode;
        parg.Params.search = this.searchFilter;
        parg.Params.field = this.searchField;
        parg.Params.currentPage = this.currentPage;

        //util.Forward(this.$router,"DSV",parg);
        parg.Params["type"] = this.outtype;

        api.execute("detail",parg).then((res) => {	
          var d = res.data;
          if (typeof(d) === "string") d = JSON.parse(res.data);   // convert non-aws string to 
          this.outdata = d.payload.outdata;
          this.viewDetailsVisible = true;
          this.listLoading = false;
				});

      },


      handleXml: function (row,mode) {
        let parg = {};
        parg.Params = {};
        parg.Params.site = this.sitecode;
        parg.Params.dosid = row.D;
        parg.Params.period = this.periode;
        parg.Params.search = this.searchFilter;
        parg.Params.field = this.searchField;
        parg.Params.currentPage = this.currentPage;

        ///util.Forward(this.$router,"DSX",parg);
        parg.Params = {};
        parg.Params.site = this.sitecode;
        parg.Params.dosid = row.D;
        parg.Params.period = this.periode;
        parg.Params.search = this.searchFilter;
        parg.Params.field = this.searchField;
        parg.Params.currentPage = this.currentPage;
        parg.Params.mode = mode;
    
				this.listLoading = true;

				api.execute("xml",parg).then((res) => {	
          var d = res.data;
          if (typeof(d) === "string") d = JSON.parse(res.data);   // convert non-aws string to 
          
          this.xmldata = d.payload.xml;
          this.xmlfile = d.payload.xmlfile;
          this.dossier = parg.Params.dosid;
          this.viewXmlVisible = true;
          this.listLoading = false;
				});

			},
			
			
			// Toon nieuwe interface
			handleImport: function () {
        let parg = {};       
        parg.Params = {};
        parg.Params.sites = this.codes.sites;
        parg.Params.site = this.sitecode;
        parg.Params.period = this.periode;
        parg.Params.search = this.searchFilter;
        parg.Params.field = this.searchField;
        parg.Params.currentPage = this.currentPage;

        util.setSessionValue("site",this.sitecode);
        util.setSessionValue("period",this.periode);

        util.Forward(this.$router,"IMP",parg);
			},

			// uitgeven
			/*
      editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
					  this.editLoading = true;
						
						let parg = Object.assign({}, this.editForm);

            if (this.editMode == "add") 
            {
							api.addRecord(parg).then((res) => {
                if (res.data.header.OK)
                  this.$notify({title: text.data.done, type: 'success',
								                message: text.getText("addOK",this.mainSubject,this.editForm.loaderversion)});
                else this.$notify({title: "Error",type: 'error',message: res.data.header.message});
		    				this.$refs['editForm'].resetFields();
        				this.editLoading = false;  
	  		    		this.editFormVisible = false;
   			 	  		this.getRecords();
	  					});
            }
						else {
							api.saveRecord(parg).then((res) => {		  					
                if (res.data.header.OK)
                  this.$notify({title: text.data.done, type: 'success',
								                message: text.getText("modOK",this.mainSubject,this.editForm.loaderversion)});
                else this.$notify({title: "Error",type: 'error',message: res.data.header.message});
						    this.$refs['editForm'].resetFields();
        				this.editLoading = false;  
	  		    		this.editFormVisible = false;
		    				this.getRecords();
	  					});
            }
					}
				});
			},
      */
		},

		mounted() {
      
      window.addEventListener("popstate", (event) => {
        this.closeForm();
      });

      this.userDepts = sessionStorage.getItem("depts");
      this.userRoles = sessionStorage.getItem("roles");


      
      if (this.$route.params) {
        this.stack = this.$route.params;
        
         if (this.stack.Params)
        {
          this.sitecode = this.stack.Params.site;
          this.periode = this.stack.Params.period;
          this.searchFilter = this.stack.Params.search;
          this.searchField = this.stack.Params.field;
          this.currentPage = this.stack.Params.currentPage;
        }
        else {
          if (window.sessionStorage.getItem("site"))
            this.sitecode = window.sessionStorage.getItem("site"); // = util.setSessionValue("site");
          if (window.sessionStorage.getItem("period"))
            this.periode = window.sessionStorage.getItem("period"); //util.setSessionValue("period");
        }
      }
			
      this.related = settings.getRelated();
			this.getRecords();
		}
	}

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// dossier.vue?8cd2c508